import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I am Tanmay Tirpankar`}</h1>
    <p>{`This website is a work in progress and by the end of it, each project will have a corresponding web interface for you to try out.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      